
export default {
  setUser ({commit}, user) {
    commit('userStatus', user)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js